type NavigationBarProps = {
  questions: any[];
  currentIndex: number;
  handleQuestionJump: (index: number) => void;
  userAnswers: Record<string, string[]>;
};

const NavigationBar = ({
  questions,
  currentIndex,
  handleQuestionJump,
  userAnswers
}: NavigationBarProps) => {
  return (
    <div className='mt-6 flex flex-col items-center gap-4 rounded-xl border border-blue-100 bg-blue-50/30 p-4'>
      <div className='flex flex-wrap justify-center gap-2'>
        {questions.map((q, index) => {
          const isAnswered = !!userAnswers[q.id];
          const isCurrent = currentIndex === index;

          return (
            <button
              key={q.id}
              onClick={() => handleQuestionJump(index)}
              className={`h-10 w-10 rounded border text-sm font-bold transition-all
                ${
                  isCurrent
                    ? 'border-2 border-blue-700 bg-white text-blue-700'
                    : isAnswered
                      ? 'border-blue-600 bg-blue-600 text-white'
                      : 'border-gray-200 bg-white text-gray-400'
                }
              `}
            >
              {index + 1}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default NavigationBar;
